var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_c('div',{staticClass:"carousel-inner"},[_c('VueSlickCarousel',{attrs:{"arrows":true,"dots":false,"autoplay":true,"autoplaySpeed":3000,"speed":1000}},[_c('HomeSlider',{attrs:{"images":_vm.image1}}),_c('HomeSlider',{attrs:{"images":_vm.image2}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }